module.exports = __webpack_public_path__ + "72fac02549a20c728c9667db01351999.png";